import { create } from 'zustand';

export const useFilterStore = create((set) => ({
  search: '',
  categoryId: '',
  sortBy: 'popular',
  minPrice: '',
  maxPrice: '',
  mobileFiltersOpen: false,

  setSearch: (search) => set({ search }),
  setCategoryId: (categoryId) => set({ categoryId }),
  setSortBy: (sortBy) => set({ sortBy }),
  setMinPrice: (minPrice) => set({ minPrice }),
  setMaxPrice: (maxPrice) => set({ maxPrice }),
  setMobileFiltersOpen: (open) => set({ mobileFiltersOpen: open }),
  resetFilters: () =>
    set({
      search: '',
      categoryId: '',
      sortBy: 'popular',
      minPrice: '',
      maxPrice: '',
    }),
}));
